import qs from "qs";

export class LogClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/log`;
  }

  async getListByFeature(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}/${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response.data.result;
  }
}
